import { IconProps } from '.';

function AccordionDownloadIcon({ color, className }: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 25"
      fill='#CDD3CD'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <title>Download de documentos</title>
      <path fillRule="evenodd" clipRule="evenodd" d="M7.37493 11.2878L11.5 15.9632V2.78467C11.5 2.50853 11.7239 2.28467 12 2.28467C12.2761 2.28467 12.5 2.50853 12.5 2.78467V16.0211L16.6352 11.6097C16.8241 11.4082 17.1405 11.398 17.3419 11.5869C17.5434 11.7757 17.5536 12.0921 17.3648 12.2936L12.3648 17.6276C12.1632 17.8427 11.8201 17.8375 11.6251 17.6164L6.62507 11.9494C6.44237 11.7424 6.46213 11.4264 6.6692 11.2437C6.87627 11.061 7.19223 11.0808 7.37493 11.2878ZM22 12.7847C22 12.5085 21.7761 12.2847 21.5 12.2847C21.2239 12.2847 21 12.5085 21 12.7847V21.1692C21 21.233 20.9483 21.2847 20.8845 21.2847H3.1155C3.05171 21.2847 3 21.233 3 21.1692L3 12.7847C3 12.5085 2.77614 12.2847 2.5 12.2847C2.22386 12.2847 2 12.5085 2 12.7847V22.0886C2 22.1969 2.08779 22.2847 2.19608 22.2847H21.8039C21.9122 22.2847 22 22.1969 22 22.0886V12.7847Z" fill={color} />
    </svg>
  );
}

export default AccordionDownloadIcon;
